<template>
  <div class="batch-upload-title">
    <div>
      插入动态词包：
      <el-link v-for="word in pageConfig.word_list" :key="word" class="mr-10" :underline="false" type="primary" @click="insertStr(replaceContext(pageConfig.word_template, word))">+{{ word }}</el-link>
    </div>
    <div class="title-list-box">
      <div class="fl">
        <ul>
          <li v-for="index of pageConfig.rules.max_count" :key="index">
            <span :class="[{ 'title-index': true }, { 'title-wrong': add_title_list.length < index ? false : add_title_list[index - 1].is_success ? false : true }]">{{ index }}</span>
          </li>
        </ul>
      </div>
      <div class="fr title-input-list">
        <ul>
          <li v-for="(item, index) in add_title_list" :key="index">
            <div :class="[{ 'title-input': true }, { 'input-action': title_input_index === index }]">
              <input
                ref="inputRename"
                v-model="item.name"
                placeholder="请输入或粘贴创意标题，每行一标题，敲击回车换行"
                @keydown="inputDown"
                @keyup="inputUp"
                @focus="setFocusIndex(index)"
                @blur="blurEvent"
                @input="inputEvent"
              >
              <i v-if="title_input_index != index" class="el-icon-close" @click.stop="deleteItemTitle(item)" />
              <span v-if="title_input_index === index">
                {{ getStrLen(item.name) }}/{{ pageConfig.rules.max_length }}
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <p v-if="is_title_tips" style="color: #f45858">
      <span>以下标题不符合{{ pageConfig.rules.min_length }}-{{ pageConfig.rules.max_length }}个字：</span>
      <span v-for="(item, index) in wrong_list" :key="index" style="color: #2f88ff">第{{ item + 1 }}行</span>
    </p>
    <p v-if="is_show_use_word_tips" style="color: #f45858">
      <span>以下标题最多能使用{{ pageConfig.rules.use_word_limit }}个动态词包：</span>
      <span v-for="(item, index) in use_word_wrong_list" :key="index" style="color: #2f88ff">第{{ item + 1 }}行</span>
    </p>
  </div>
</template>

<script>
import TitleResource from '@/api/title';
const titleResource = new TitleResource();

export default {
  props: {
    // 页面配置
    pageConfig: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      title_input_index: 0, // 输入标题行数的索引位置
      is_title_tips: false, // 是否显示提示
      wrong_list: [], // 错误提示列表
      add_title_list: [{ name: '', is_success: true }], // 添加的标题数组，is_success代表标题满足规则
      key_code: null, // 键码

      is_show_use_word_tips: false, // 是否动态词包提示
      use_word_wrong_list: [], // 动态词包错误提示列表
    };
  },
  methods: {
    /**
     * 替换文本
     * @param {string} template 词包模板
     * @param {string} value 输入的值
     * @returns {string}
     */
    replaceContext(template, value) {
      return template.replace(/context/g, value);
    },

    /**
     * 批量新增插入动态词包
     * @param {string} str 词包
     * @returns {void}
     */
    insertStr(str) {
      const index = this.title_input_index;
      this.add_title_list[index].name += str;
      this.verifyText(this.add_title_list[index].name);
    },

    /**
     * 输入框enter换行
     * @param {Object} event 事件对象
     */
    inputUp(event) {
      if (event.keyCode === 13 || (this.key_code === 17 && event.keyCode === 86)) {
        const s = this;
        this.blurEvent();
        if (this.add_title_list.length < s.pageConfig.rules.max_count) {
          this.title_input_index++;
          if (this.title_input_index === this.add_title_list.length) {
            this.add_title_list.push({ name: '', is_success: true });
          }
          this.$nextTick(() => {
            s.$refs.inputRename[this.title_input_index].focus();
          });
        }
      }
    },

    /**
     * 输入框摁下ctrl
     * @param {Object} event 事件对象
     */
    inputDown(event) {
      if (event.keyCode !== 86) {
        this.key_code = event.keyCode;
      }
    },

    /**
     * 输入框事件
     * @param {Object} event 事件对象
     */
    inputEvent(event) {
      this.verifyText(event.target.value);
    },

    /** 焦点事件 */
    blurEvent() {
      const val = this.add_title_list[this.title_input_index].name;
      const temp_list = val.split(/\s+/);

      for (let i = 0; i < temp_list.length; i++) {
        const item = temp_list[i];
        if (i > 0) {
          this.add_title_list.push({ name: item, is_success: false });
          this.title_input_index = this.add_title_list.length - 1;
          this.verifyText(item);
        } else {
          this.add_title_list[this.title_input_index].name = item;
          this.verifyText(item);
        }
      }
    },
    /**
     * 验证文本
     * @param {string} val 需效验的标题文本
     */
    verifyText(val) {
      let isLen = false;
      const item = this.add_title_list[this.title_input_index];
      if (this.getStrLen(val) >= this.pageConfig.rules.min_length && this.getStrLen(val) <= this.pageConfig.rules.max_length) {
        isLen = true;
      }
      if (isLen || val.length === 0) {
        item.is_success = true;
        const wrong_index = this.wrong_list.indexOf(this.title_input_index);
        if (wrong_index !== -1) {
          this.wrong_list.splice(wrong_index, 1);
        }
      } else {
        item.is_success = false;
        if (this.wrong_list.indexOf(this.title_input_index) === -1) {
          this.wrong_list.push(this.title_input_index);
        }
      }
      if (this.wrong_list.length === 0) {
        this.is_title_tips = !item.is_success;
      } else {
        this.is_title_tips = true;
      }

      // 检查使用动态词包个数
      const { getUseWordCount, rules } = this.pageConfig;
      if (rules.use_word_limit && getUseWordCount(val) > rules.use_word_limit) {
        item.is_success = false;
        if (this.use_word_wrong_list.indexOf(this.title_input_index) === -1) {
          this.use_word_wrong_list.push(this.title_input_index);
        }
      } else {
        item.is_success = isLen || val.length === 0;
        const wrong_index = this.use_word_wrong_list.indexOf(this.title_input_index);
        if (wrong_index !== -1) {
          this.use_word_wrong_list.splice(wrong_index, 1);
        }
      }
      if (this.use_word_wrong_list.length === 0) {
        this.is_show_use_word_tips = false;
      } else {
        this.is_show_use_word_tips = !!rules.use_word_limit;
      }
    },

    /**
     * 获取字符长度
     * @param {string} str 字符串
     */
    getStrLen(str) {
      return str.length;
    },

    /**
     * 设置焦点索引
     * @param {number} index 当前输入框索引
     */
    setFocusIndex(index) {
      this.title_input_index = index;
    },

    /**
     * 批量添加
     * @param {Object[]} title_list
     */
    async onBatchAdd(title_list = this.add_title_list) {
      const { advertiser } = this.pageConfig;
      const success_list = title_list.filter(({ is_success, name }) => is_success && name);
      const names = success_list.map(({ name }) => name);
      if (!names.length) {
        return Promise.reject(new Error('names cannot be empty.'));
      }
      await titleResource.batchCreatApi({ advertiser, names });
      return Promise.resolve(success_list);
    },
  },
};
</script>

<style lang="scss" scoped>
.title-list-box {
  height: 375px;
  overflow: auto;
  .title-input-list {
    width: 95%;
    width: calc(100% - 36px);
    width: -moz-calc(100% - 36px);
    width: -webkit-calc(100% - 36px);
  }
  ul {
    padding: 0;
    li {
      list-style-type: none;
      .title-index {
        display: block;
        float: left;
        width: 36px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background-color: #edf1f5;
      }
      .title-wrong {
        background-color: red;
        color: #edf1f5;
      }
      .title-input {
        input {
          width: 95%;
          height: 36px;
          border: none;
          background: transparent;
        }
      }
      .input-action {
        background-color: #edf1f5;
      }
    }
  }
}
</style>
